export default {
  common_button_back: 'Wstecz',
  common_button_cancel: 'Anuluj',
  common_button_next: 'Dalej',
  common_button_no: 'Nie',
  common_button_ok: 'OK',
  common_button_reset: 'Reset',
  common_button_skip: 'Pomiń',
  common_button_yes: 'Tak',
  common_deactivated_message:
    'Ten kiosk został aktywowany na innym iPadzie i tym samym jest już nieaktywny na tym iPadzie. Proszę ponownie się zalogować. Dziękuję!',
  common_deactivated_title: 'Kiosk zdezaktywowany na tym iPadzie',
  common_enterEmail_email: 'Wprowadź adres e-mail firmy',
  common_enterEmail_title: 'Twój e-mail',
  common_error_message_cameraNotAllowed: 'Aby korzystać z tej funkcji, zezwól na dostęp do kamery.',
  common_error_message_ForbiddenException: 'Niewystarczające uprawnienia',
  common_error_message_incorrectEmail: 'Podaj poprawny adres e-mail',
  common_error_message_invalidCredentials: 'Oops! Nieprawidłowa nazwa użytkownika i/lub hasło. Spróbuj ponownie',
  common_error_message_invalidMobile: 'Wprowadź prawidłowy numer telefonu komórkowego',
  common_error_message_missingField: 'Pole obowiązkowe',
  common_error_message_noInternetConnection: 'Utracono połączenie z Internetem. Proszę spróbować ponownie.',
  common_error_message_unauthorizedAccess: 'Nieuprawniony dostęp',
  common_error_message_webServiceWrongConnection: 'Wystąpił błąd podczas transferu danych. Spróbuj ponownie',
  common_error_title: 'Błąd',
  common_expired_message:
    'Albo zakończył się okres próbny albo zarejestrowana u nas karta kredytowa przestała działać. Proszę dokonać zakup planu w celu ponownej aktywacji konta. Jeśli masz jakiekolwiek pytania, skontaktuj się z sales@proxyclick.com. Dziękuję!',
  common_expired_title: 'Konto wygasło',
  common_onboarding_login_button: 'Zaloguj się',
  common_onboarding_message1: 'Proxyclick pomaga zawitać Twoich gości dokładnie tak, jak chcesz.',
  common_onboarding_message2:
    'Oznakuj swój proces rejestracji gości, w tym odznaki i zadawaj gościom tylko pytania, które ich dotyczą.',
  common_onboarding_message3:
    'Opiekunowie gości otrzymują powiadomienia, gdy ich goście przyjechali i natychmiast mogę odpowiedzieć.',
  common_onboarding_message4:
    'Chroń swoje obiekty i zapewniaj przestrzeganie zasad poprzez emergency lists (listy ewakuacyjne), watch list (listy obserwacyjne), NDAs (umowa o zachowaniu poufności) lub definicję zasad prywatności...',
  common_onboarding_message5:
    'Proxyclick wykonuje tą ciężką pracę dla Ciebie żebyś Ty mógł witać swoich gości z uśmiechem.',
  common_placeholder_optional: 'Opcjonalne',
  common_setup_activationCode_activate_button: 'Aktywuj',
  common_setup_activationCode_code: 'Wprowadź swój kod aktywacyjny',
  common_setup_activationCode_code_placeholder: 'Np. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Nieprawidłowy kod aktywacyjny',
  common_setup_activationCode_footer:
    'Kod aktywacyjny jest przydatny dla administratorów logowania jednokrotnego lub dla lokalnych strażników. Dowiedz się więcej.',
  common_setup_activationCode_title: 'Aktywuj kiosk kodem unikalnym',
  common_setup_device_footer: 'Aby utworzyć nowy kiosk, podłącz się do aplikacji web Proxyclick',
  common_setup_device_locked_content:
    'Ten kiosk jest już używany na innym iPad. Ustawienie go na iPad, który masz w rękach, dezaktywuje program na tym drugim. Czy na pewno chcesz ustawić kiosk na tym iPad?',
  common_setup_device_locked_continue_button: 'Ustaw ten kiosk',
  common_setup_device_locked_title: 'Kiosk już jest w użytku',
  common_setup_device_multiTenants: 'Zespół firm',
  common_setup_device_title: 'Wybierz swój kiosk',
  common_setup_loading_footer: 'Aby personalizować swój kiosk, połącz się z aplikacją webową Proxyclick',
  common_setup_loading_message: 'Konfigurowanie...',
  common_setup_loading_title: 'Trwa konfigurowanie kiosku...',
  common_setup_location_footer: 'Aby utworzyć nową witrynę, podłącz się do aplikacji web Proxyclick',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kioski',
  common_setup_location_title: 'Wybierz swoją witrynę',
  common_setup_login_activationCode_button: 'Aktywować kodem unikalnym?',
  common_setup_login_email: 'Email',
  common_setup_login_forgotPassword_button: 'Zapomniałeś hasła?',
  common_setup_login_password: 'Hasło',
  common_setup_login_title: 'Zaloguj się za pomocą swojego konta Proxyclick',
  common_setup_ready_header: 'Czy jesteś gotowy ustawić ten iPad jako Twój {0} kiosk?',
  common_setup_ready_message: 'Konfigurowanie potrwa tylko chwilę, i Twój kiosk wkrótce będzie działał',
  common_setup_ready_setup_button: 'Ustaw',
  common_setup_ready_title: 'Witaj {0}',
  common_signup_company: 'Nazwa firmy',
  common_signup_email: 'Email',
  common_signup_error_name: 'Podaj imię i nazwisko',
  common_signup_loading_message1:
    'Możesz dostosować swój kiosk poprzez połączenie z aplikacją web Proxyclick. Właśnie wysłaliśmy Ci e-mail ze wszystkimi szczegółami.',
  common_signup_loading_message2:
    'Ze strony internetowej można skonfigurować drukarkę do drukowania identyfikatorów przy rejestracji.',
  common_signup_loading_message3: 'Można też włączyć wysyłanie powiadomień do hosta podczas rejestracji.',
  common_signup_loading_message4: 'Możesz personalizować kiosk za pomocą swoich kolorów i obrazu powitalnego.',
  common_signup_loading_title: 'Konfigurowanie konta …',
  common_signup_name: 'Imię',
  common_signup_name_placeholder: 'Imię nazwisko',
  common_signup_password: 'Hasło',
  common_signup_title: 'Witamy w Proxyclick',
  common_signup_tryFree_button: 'Prześlij',
  common_timeout_content: 'Dotknij, aby przerwać',
  common_timeout_title: 'Powrót do strony głównej',
  common_tooltip_disable_button: 'Wyłącz wszystkie porady',
  common_tooltip_gotIt_button: 'Zrozumiałe',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} został poinformowany o dostarczeniu paczki',
  dm_delivery_confirmation_title: 'Dziękuję!',
  dm_delivery_confirmation_unknownRecipient:
    'Wysłano powiadomienie informujące {{Company_Name}} dostarczyłeś dla nich paczkę',
  dm_delivery_recipient_name: 'Dla kogo przeznaczony jest ten pakiet?',
  dm_delivery_recipient_unknown_button: 'Nie wiem',
  em_multiTenant_alreadyRegistered_button:
    'Dotknij tutaj, jeśli jesteś pracownikiem lub otrzymałeś kod QR do zameldowania',
  em_multiTenant_notRegistered_button: 'Dotknij tutaj, aby zarejestrować się ręcznie',
  vm_checkin_approval_confirmation_unregistered_message:
    'W tej chwili nie możemy Cię zarejestrować. Skontaktuj się z gospodarzem lub skontaktuj się z recepcją w celu uzyskania pomocy.',
  vm_checkin_approval_confirmation_unregistered_title: 'Witamy {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'W tej chwili nie możemy sfinalizować rejestracji. Skontaktuj się z gospodarzem lub skontaktuj się z recepcją w celu uzyskania pomocy.',
  vm_checkin_approval_notapproved_title: 'Szanowni Państwo {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Zostałeś zarejestrowany!',
  vm_checkin_confirmation_header_withPrint: 'Drukowanie Twojego identyfikatora',
  vm_checkin_confirmation_message: 'Proszę usiąść, {{Host_FirstName}} wkrótce zaopiekuje się Tobą',
  vm_checkin_confirmation_takeBackID: 'Nie zapomnij o swoim dowodzie osobistym',
  vm_checkin_confirmation_title: 'Dziękuję!',
  vm_checkin_details_companyName: 'Nazwa firmy',
  vm_checkin_details_email: 'Email',
  vm_checkin_details_firstname: 'Imię',
  vm_checkin_details_lastname: 'Nazwisko',
  vm_checkin_details_title: 'Podaj swoje dane',
  vm_checkin_error_message_unableToCheckIn:
    'Podczas ukończenia rejestracji wystąpił błąd, prosimy o kontakt z recepcją',
  vm_checkin_flow_company: 'Nazwa firmy',
  vm_checkin_flow_duration: 'Czas trwania wizyty',
  vm_checkin_flow_email: 'Email',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Niestety obraz w tej chwili jest niedostępny (problem połączenia internetowego)',
  vm_checkin_flow_licensePlate: 'Tablica rejestracyjna',
  vm_checkin_flow_mobile: 'Wprowadź swój numer telefonu komórkowego',
  vm_checkin_flow_mobile_info:
    'Zostanie on wykorzystany w celu skontaktowania się z Tobą w razie sytuacji awaryjnej podczas pobytu w obiekcie',
  vm_checkin_flow_tooltip_content:
    'Pytaj gości o wszystko, czego potrzebujesz, aby poprawić ich doświadczenie bądź uczynić ich rejestrację bezpieczniejszą. Możesz zmieniać przebieg pytań w zależności od odpowiedzi odwiedzających. Pytania, które widzisz, to tylko wzorce demonstracyjne.',
  vm_checkin_flow_tooltip_title: 'Inteligentne pytania',
  vm_checkin_host_enterFullName: 'Podaj imię i nazwisko swojego zapraszającego',
  vm_checkin_host_name: 'Kogo odwiedzasz?',
  vm_checkin_host_notListed_block:
    'Jeśli nie znasz imienia swojego zapraszającego bądź nie znajdujesz go/jej na liści, proszę zgłosić się do recepcjonisty',
  vm_checkin_host_notListed_continue: 'Nie ma na liście',
  vm_checkin_host_tooltip_content:
    'Wpisz tu swoje imię, a wyślemy Ci e-mail powiadomienia, który pracownicy otrzymają w czasie przybycia odwiedzających.',
  vm_checkin_host_tooltip_title: 'Powiadomienie o przybyciu gościa',
  vm_checkin_host_unknown_button: 'Nie wiem',
  vm_checkin_idScan_aila_footer: 'Ten ekran jest pomijany podczas korzystania z zalecanego sprzętu ({0})',
  vm_checkin_idScan_aila_header: 'Zeskanuj swój dowód tożsamości',
  vm_checkin_idScan_aila_learnMore: 'Dowiedz się więcej',
  vm_checkin_idScan_aila_scan_button: 'Identyfikator skanowania',
  vm_checkin_idScan_back_picture_header_aila:
    'Umieść identyfikator w uchwycie tak, aby tył był skierowany w stronę aparatu.',
  vm_checkin_idScan_back_picture_header_noAila: 'Umieść tył identyfikatora całkowicie wewnątrz ramki.',
  vm_checkin_idScan_back_picture_take_button: 'Zeskanuj tył',
  vm_checkin_idScan_cancel_message: 'Rejestracja zostanie anulowana i powrócisz do ekranu głównego',
  vm_checkin_idScan_cancel_title: 'Uwaga',
  vm_checkin_idScan_disclaimer_start_button: 'Zacznijmy',
  vm_checkin_idScan_disclaimer_text:
    'W ramach naszej polityki bezpieczeństwa musimy zweryfikować Twoją tożsamość za pomocą Twojego dowodu tożsamości. \n\nCenimy Twoją prywatność, dlatego nie będziemy przechowywać zdjęcia Twojego dowodu osobistego. Pracownicy recepcji są dostępni, aby pomóc, jeśli masz jakiekolwiek pytania.',
  vm_checkin_idScan_editName_title: 'Proszę podać swoje imię i nazwisko',
  vm_checkin_idScan_front_picture_header_aila:
    'Umieść swój identyfikator w uchwycie tak, aby przód był skierowany w stronę aparatu.',
  vm_checkin_idScan_front_picture_header_noAila: 'Umieść swój identyfikator całkowicie wewnątrz ramki.',
  vm_checkin_idScan_front_picture_take_button: 'Skanuj przód',
  vm_checkin_idScan_match_check: 'Porównanie dwóch zdjęć',
  vm_checkin_idScan_match_confirm_button: 'Potwierdź',
  vm_checkin_idScan_match_error_default_header: 'Przepraszamy, coś poszło nie tak.',
  vm_checkin_idScan_match_error_default_message: 'Poproś recepcjonistkę o pomoc lub spróbuj ponownie.',
  vm_checkin_idScan_match_error_idExpired_header: 'Przepraszamy, wydaje się, że Twój identyfikator wygasł.',
  vm_checkin_idScan_match_error_idExpired_message: 'Poproś recepcjonistkę o pomoc lub spróbuj ponownie.',
  vm_checkin_idScan_match_error_idNoFace_header:
    'Przepraszamy, nie udało nam się zidentyfikować twarzy na Twoim dowodzie tożsamości.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Poproś recepcjonistkę o pomoc lub spróbuj ponownie.',
  vm_checkin_idScan_match_error_pictureNoFace_header:
    'Przepraszamy, nie udało nam się zidentyfikować twarzy na zdjęciu.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Poproś recepcjonistkę o pomoc lub spróbuj ponownie.',
  vm_checkin_idScan_region_0: ' Stany Zjednoczone',
  vm_checkin_idScan_region_1: ' Kanada',
  vm_checkin_idScan_region_2: 'Ameryka Południowa',
  vm_checkin_idScan_region_3: ' Europa',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Azja',
  vm_checkin_idScan_region_6: ' Dokumenty ogólne',
  vm_checkin_idScan_region_7: ' Afryka',
  vm_checkin_idScan_region_header: 'Z jakiego regionu pochodzi Twój identyfikator?',
  vm_checkin_instructions_agreeTerms_button: 'Zgadzam się',
  vm_checkin_instructions_clearSignature_button: 'Wyczyść',
  vm_checkin_instructions_sendCopy_button: 'Wyślij mi kopię na email',
  vm_checkin_instructions_sendCopyTo_button: 'Kopia zostanie wysłana do {0} (Zmień)',
  vm_checkin_instructions_sign: 'Podpisz się tu za pomocą odcisku palca',
  vm_checkin_instructions_tooltip_content:
    'Zaproś swoich gości do zaakceptowania reguł dla odwiedzających za pomocą prostego dotyku bądź podpisu. Możesz dostosować swoje warunki w zależności od typu rejestrującego się gościa. Personalizuj tę funkcję i wiele innych na panelu narzędzi.',
  vm_checkin_instructions_tooltip_title: 'Podpisane i przypieczętowane',
  vm_checkin_method_name: 'Witaj, jak masz na imię?',
  vm_checkin_method_name_enterFullName: 'Wpisz swoje imię i nazwisko',
  vm_checkin_method_name_invitationQuestion: 'Czy otrzymałeś zaproszenie z kodem QR?',
  vm_checkin_method_name_notRegistered_block: 'Nie ma na liście? Proszę skontaktować się z recepcją',
  vm_checkin_method_name_notRegistered_continue: 'Nie ma na liście?',
  vm_checkin_method_tooltip_content:
    'Zarejestruj się jako "Justin Diaz", aby zobaczyć, w jaki sposób się rozpoznaje powracających bądź uprzednio zarejestrowanych gości. \nMożesz też wpisać losowe imię, aby zobaczyć, w jaki sposób się przyjmuje nieoczekiwanych gości.',
  vm_checkin_method_tooltip_title: 'Rozpoznanie odwiedzającego',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Proszę spojrzeć na aparat, zrobimy twojemu gościowi zdjęcie',
  vm_checkin_picture_auto_pictureTaken: 'Zdjęcie zrobione',
  vm_checkin_picture_auto_stayStill: 'Pozostań nieruchomy',
  vm_checkin_picture_take_button: 'Zrób zdjęcie',
  vm_checkin_picture_title: 'Zróbmy zdjęcie!',
  vm_checkin_picture_tooltip_content:
    'Możesz dostosować kiosk do własnych potrzeb i łatwo dodawać bądź usuwać funkcje (fotografowanie odwiedzających, drukowanie identyfikatorów itd.).',
  vm_checkin_picture_tooltip_title: 'Funkcje opcjonalne',
  vm_checkin_qrcode_no_checkin_allowed:
    'Zarejestrowania niedozwolone. Prosimy o kontakt z recepcją w celu uzyskania pomocy.',
  vm_checkin_returning_email: 'Witaj, jaki masz adres mailowy?',
  vm_checkin_returning_email_notRegistered:
    'Nie możemy znaleźć zaplanowanej wizyty powiązanej z Twoim adresem e-mail. Skontaktuj się z recepcją lub spróbuj ponownie, podając inny adres e-mail.',
  vm_checkin_saveInfo_email: 'Zapisz moje informacje, aby przyspieszyć moją następną rejestracje',
  vm_checkin_saveInfo_email_placeholder: 'Wpisz swój adres e-mail',
  vm_checkin_saveInfo_title: 'Wpisz swój adres e-mail',
  vm_checkin_summary_agreementAlreadySigned: 'Umowa już podpisana',
  vm_checkin_summary_checkin_button: 'Rejestracja',
  vm_checkin_summary_countDown: 'Rejestracja nastąpi po',
  vm_checkin_summary_editDetails_button: 'Edytuj szczegóły',
  vm_checkin_summary_groupStats: '{0} z {1} osób już są tam',
  vm_checkin_summary_meetingTime: 'Spotkanie o {0}',
  vm_checkin_summary_reviewDetails_button: 'Podsumuj szczegóły mojej wizyty',
  vm_checkin_summary_sendPass_button: 'Wyślij mi na smartfon kartę dostępu dla przyszłych wizyt',
  vm_checkin_summary_sendPassTo_button: 'Stała karta dostępu będzie wysłana na {0} (Zmień)',
  vm_checkin_summary_takeNewPicture_button: 'Zrób nowe zdjęcie',
  vm_checkin_summary_title: 'Twoja wizyta w {{Company_Name}}',
  vm_checkin_summary_visiting: 'Odwiedza {0}',
  vm_checkin_video_duration: 'Czas trwania',
  vm_checkin_video_subtitle: 'Obejrzyj cały film, aby kontynuować rejestrację.',
  vm_checkin_welcome_firstTime: 'Witamy {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Twoja ostatnia wizyta odbyła się {0}',
  vm_checkin_welcome_lastVisit_today: 'Twoja ostatnia wizyta miała miejsce już dzisiaj',
  vm_checkin_welcome_lastVisit_yesterday: 'Twoja ostatnia wizyta była wczoraj',
  vm_checkin_welcome_returning: 'Witamy z powrotem {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Do zobaczenia {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Zostałeś wyrejestrowany. Mamy nadzieję, że jesteś zadowolony z wizyty.',
  vm_checkout_confirmation_title: 'Dziękujemy za wizytę!',
  vm_checkout_method_name: 'Podaj swoje imię i nazwisko, aby się wyrejestrować',
  vm_checkout_method_name_notFound: 'Nie znaleziono',
  vm_checkout_method_title: 'Wyrejestrujmy się',
  vm_identification_id_button: 'Zeskanuj swój ID',
  vm_identification_qrCode_button: 'Zeskanuj swoje zaproszenie/kartę wstępu',
  vm_infopack_confirmation: 'Dziękujemy! Informacja została wysłana do {0}.',
  vm_infopack_email: 'Wprowadź adres e-mail, abyśmy mogli wysłać Ci informacje o Proxyclick',
  vm_infopack_likeCheckIn: 'Podobała Ci się rejestracja? Dotknij tutaj, aby dowiedzieć się więcej',
  vm_infopack_likeProcess: 'Podobał Ci się ten proces? Dotknij tutaj, aby dowiedzieć się więcej',
  vm_infopack_send_button: 'Wyślij mi informacje',
  vm_multiTenant_title: 'Witamy, którą firmę odwiedzasz?',
  vm_product_footer_learnMore: 'Dowiedz się więcej',
  vm_product_footer_noPartner: 'Używasz Proxyclick Welcome',
  vm_product_footer_partner: 'Używasz Proxyclick Welcome, dostarczonego przez {0}',
  vm_qrCode_help: 'Trzymaj swój kod 10-15 cm od kamery',
  vm_qrCode_not_recognized: 'Nie rozpoznano kodu',
  vm_qrCode_title: 'Zeskanuj swój identyfikator lub kod Passbook',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>INSTRUKCJE UŻYTKOWNIKA I UMOWA O ZACHOWANIU POUFNOŚCI</h1><p>Witamy! Z radością przyjmujemy Cię jako gościa {{Company_Name}} w naszych zasobach.</p><h2>Instrukcje dotyczące zdrowia i bezpieczeństwa</h2><p>W czasie Twojej wizyty troszczymy my się o Twoje osobiste bezpieczeństwo. Dlatego prosimy o przestrzeganie następujących zasad:</p><ul><li><b>Dostęp do pomieszczeń</b> jest dozwolony tylko w towarzystwie pracownika {{Company_Name}} </li><li><b>Identyfikator</b> odwiedzającego należy nosić cały czas oraz przy odbyciu zwrócić na recepcję</li><li>W przypadku <b>niebezpieczeństwa</b>, wszyscy odwiedzający powinni natychmiast opuścić pomieszczenia przez najbliższe bezpieczne wyjście i zgłosić się do określonego punku zbiórki</li><li>Odwiedzającym <b>zabrania się robienia zdjęć</b> (foto i wideo) czegokolwiek wewnątrz pomieszczeń bądź na obszarze otaczającym placówkę</li><li><b>Obowiązuje całkowity zakaz palenia</b> wewnątrz budynku</li></ul><h2>Umowa poufności</h2><p>W czasie Twojej wizyty na obiektach {{Company_Name}}możesz dowiedzieć się i/lub Ci mogą być ujawnione zastrzeżone i poufne informacje (w tym nie ograniczając się informacje o technologii, procesach, wyposażeniu, rysunkach technicznych i specyfikacjach), które nie są powszechnie znane publiczności (zwane dalej razem &#34;Informacjami poufnymi&#34;).</p><p>Z uwagi na Twoje zezwolenie do odwiedzenia obiektów {{Company_Name}} uprzejmie zgadzasz się w czasie wizyty i w przyszłości do nieujawnienia żadnych Informacji poufnych, ujawnionych Ci w czasie tej i każdej kolejnej wizyty; bądź</p><p>(b) użycia bądź pomagania innym w użyciu bądź dalszym rozwoju w jakikolwiek sposób informacji poufnych.</p><p>(c) Używać kamer lub technologii wideo do ujawnienia informacji pufnych.</p><p>Rejestrując się na obiekcie przyjmujesz do wiadomości i rozumiesz Instrukcje dotyczące zdrowia i bezpieczeństwa oraz Umowę poufności.</p>',
  vm_signup_defaultInstruction_name: 'Instrukcje muszą być podpisane przez wszystkich odwiedzających',
  vm_signup_defaultInstruction_title: 'Proszę przeczytać i podpisać poniżej',
  vm_vaccine_certification_accessDenied_button: 'W porządku',
  vm_vaccine_certification_accessDenied_message:
    'Przykro mi, że nie spełniasz wymagań dotyczących szczepień, aby wprowadzić założenia',
  vm_vaccine_certification_accessDenied_title: 'Odmówiono dostępu',
  vm_vaccine_certification_declare_question_title:
    'Szanowny Gościu, proszę zadeklarować, czy posiadasz ważny certyfikat szczepionki COVID lub test COVID z wynikiem negatywnym',
  vm_vaccine_certification_intro_question_title: 'Drogi gościu, czy masz certyfikat szczepionki COVID UE?',
  vm_vaccine_certification_scanner_donthaveaqrcode: 'Nie mam kodu QR',
  vm_vaccine_certification_scanner_subtitle:
    'Upewnij się, że kod QR jest powiększony, a jasność telefonu komórkowego jest maksymalna.',
  vm_vaccine_certification_scanner_title: 'Prosimy o okazanie do aparatu kodu QR certyfikatu UE COVID',
  vm_welcome_changeLanguage_button: 'Change language',
  vm_welcome_checkin_button: 'Rejestracja',
  vm_welcome_checkout_button: 'Wyrejestruj się',
  vm_welcome_delivery_button: 'Dostawa',

  vm_welcome_hello_line1: 'Witamy,',

  vm_welcome_hello_line2: 'w {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: 'Witaj {0}, nie zapomnij wymeldować się przed wyjazdem',
  vm_welcome_qrCode_checkedOut: 'Dziękujemy za wizytę, {0}!',
  vm_welcome_qrCode_notRecognized: 'Ten kod QR nie jest rozpoznawany. Spróbuj ponownie.',
  vm_welcome_qrCode_scan:
    'Wstępnie zarejestrowani goście: trzymaj swój kod QR w aparacie, aby zameldować się lub wymeldować',
  vm_welcome_qrCode_show: 'Pracownicy: zeskanuj ten kod QR za pomocą Proovr, aby się zameldować lub wymeldować',
  vm_welcome_qrCode_wrongCompany: 'Twój kod QR jest nieprawidłowy dla tej lokalizacji.',
  vm_welcome_returning_button: 'Już tu byłam/-em',
  vm_welcome_title: 'Witamy w {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Aby personalizować swój kiosk, zaloguj się do aplikacji webowej Proxyclick. Właśnie wysłaliśmy Ci e-mail ze wskazówkami. W aplikacji webowej możesz przesłać swoje logo, obraz tła i wybrać kolor, aby Twój kiosk odzwierciedlał tożsamości Twojej marki.',
  vm_welcome_tooltip_title: 'Personalizuj',
  vm_welcome_touchless_employee_qrCode_show:
    'Zeskanuj ten kod QR za pomocą Proovr, aby zarejestować się jako pracownik',
  vm_welcome_touchless_qrCode_show:
    'Niezarejestrowani goście: Zeskanuj ten kod QR, aby dokonać bezdotykowego zarejestrowania',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Zeskanuj ten kod QR za pomocą Proovr (pracownicy) lub telefonu (odwiedzający), aby się zarejestrować',
  vm_welcome_touchless_unexpected_qrCode_show: 'Zeskanuj ten kod QR za pomocą telefonu, aby zarejestować się jako gość',
  common_or: 'lub',
};
